export const deepCopy = (object: any): any => {
  return JSON.parse(JSON.stringify(object));
};
